// Module
var code = `<div class="col-lg-12" style="text-align: center">
    <h4>Общее количество инсталлов: {{ vm.total_install_count }}</h4>
</div>
<div class="col-lg-12">
    <bfg-chart name="runner_battler.RbShortRetentionBySecondsChart"></bfg-chart>
</div>
<div class="col-lg-12">
    <bfg-chart name="runner_battler.RbShortRetentionByMinutesChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;